// extracted by mini-css-extract-plugin
export default {"container":"indent_container__+Ltgk","inner":"indent_inner__nHoij","img-container":"indent_img-container__RdJHk"};